import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const WORDS = ["HYDRATE.", "SMOOTH.", "REVITALISE.", "BOOST."];

const SignatureMoment = () => {
  const ref = useRef(null);
  const { scrollYProgress: p } = useScroll({ target: ref, offset: ["start start", "end end"] });

  const bgScale = useTransform(p, [0, 1], [1.05, 1.22]);

  const oBacio = useTransform(p, [0.02, 0.12, 0.3, 0.4], [0, 1, 1, 0]);
  const yBacio = useTransform(p, [0.02, 0.12], [60, 0]);
  const sBacio = useTransform(p, [0.02, 0.4], [0.92, 1.05]);

  const oBooster = useTransform(p, [0.44, 0.54, 0.62, 0.7], [0, 1, 1, 0]);
  const yBooster = useTransform(p, [0.44, 0.54, 0.62, 0.7], [60, 0, 0, -50]);

  const oWords = useTransform(p, [0.74, 0.8], [0, 1]);
  const w0o = useTransform(p, [0.78, 0.83], [0, 1]);
  const w0y = useTransform(p, [0.78, 0.83], [36, 0]);
  const w0b = useTransform(p, [0.78, 0.83], ["blur(10px)", "blur(0px)"]);
  const w1o = useTransform(p, [0.83, 0.88], [0, 1]);
  const w1y = useTransform(p, [0.83, 0.88], [36, 0]);
  const w1b = useTransform(p, [0.83, 0.88], ["blur(10px)", "blur(0px)"]);
  const w2o = useTransform(p, [0.88, 0.93], [0, 1]);
  const w2y = useTransform(p, [0.88, 0.93], [36, 0]);
  const w2b = useTransform(p, [0.88, 0.93], ["blur(10px)", "blur(0px)"]);
  const w3o = useTransform(p, [0.93, 0.98], [0, 1]);
  const w3y = useTransform(p, [0.93, 0.98], [36, 0]);
  const w3b = useTransform(p, [0.93, 0.98], ["blur(10px)", "blur(0px)"]);
  const wStyles = [
    { opacity: w0o, y: w0y, filter: w0b },
    { opacity: w1o, y: w1y, filter: w1b },
    { opacity: w2o, y: w2y, filter: w2b },
    { opacity: w3o, y: w3y, filter: w3b },
  ];

  return (
    <section ref={ref} data-testid="signature-moment" className="relative h-[340vh] bg-[#1C1417]">
      <div className="sticky top-0 h-screen overflow-hidden">
        <motion.img
          src="/assets/lips-macro.webp"
          alt="Macro detail of naturally hydrated lips"
          style={{ scale: bgScale }}
          className="absolute inset-0 w-full h-full object-cover will-change-transform"
        />
        <div className="absolute inset-0 bg-[#1C1417]/55" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1C1417]/60 via-transparent to-[#1C1417]/70" />

        <motion.div
          style={{ opacity: oBacio, y: yBacio, scale: sBacio }}
          className="absolute inset-0 flex items-center justify-center"
        >
          <p
            data-testid="signature-bacio-word"
            style={{ backgroundImage: "url('/assets/lips-macro.webp')" }}
            className="font-serif font-light text-clip-lips leading-none tracking-[0.06em] text-[26vw] sm:text-[20vw] select-none"
          >
            BACIO
          </p>
        </motion.div>

        <motion.div
          style={{ opacity: oBooster, y: yBooster }}
          className="absolute inset-0 flex flex-col items-center justify-center px-6"
        >
          <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.45em] text-[#F4EBE6]/80 mb-6">
            SKINFILL BACIO®
          </p>
          <p className="font-serif font-light text-[#FAF7F5] text-[11vw] sm:text-7xl lg:text-8xl leading-[1.02] text-center">
            THE LIP
            <br />
            <span className="italic text-[#E893AE]">BOOSTER</span>
          </p>
        </motion.div>

        <motion.div
          style={{ opacity: oWords }}
          className="absolute inset-0 flex flex-col items-center justify-center gap-2 sm:gap-3 px-6"
        >
          {WORDS.map((w, i) => (
            <motion.p
              key={w}
              style={wStyles[i]}
              className={`font-serif font-light text-[9.5vw] sm:text-6xl lg:text-7xl leading-[1.05] ${
                i % 2 ? "italic text-[#E893AE]" : "text-[#FAF7F5]"
              }`}
            >
              {w}
            </motion.p>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SignatureMoment;
